import {
  Card,
  CardContent,
  CardHeader, Typography
} from "@mui/material";
import { useAppSelector } from "../../app/hooks";
import { selectGroups } from "../../features/daoTrang/daoTrangSlice";

const reg = new RegExp(/Tổ (\d)/i);
export const UserCard = ({ user }) => {
  // console.log(user)
  const { name, zalo, facebook, address, address2 } = user;
  return (
    <Card sx={{maxWidth:300, minWidth:300}}>
      <CardHeader title={name}></CardHeader>
      <CardContent>
        <Typography>{zalo}</Typography>
        <Typography>{address}</Typography>
        <Typography>{address2}</Typography>
      </CardContent>
    </Card>
  );
};
